import { render } from "./ActieEvaluaties.vue?vue&type=template&id=28320141&scoped=true"
import script from "./ActieEvaluaties.vue?vue&type=script&lang=js"
export * from "./ActieEvaluaties.vue?vue&type=script&lang=js"

import "./ActieEvaluaties.vue?vue&type=style&index=0&id=28320141&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28320141"]])

export default __exports__